<template>
  <div class="poster-list">
    <div class="page-actions">
      <el-table :data="poserlist">
        <el-table-column prop="posterType" label="海报类型">
          <template slot-scope="scope">
            <span v-if="scope.row.posterType == 1">邀请海报</span>
          </template>
        </el-table-column>
        <el-table-column prop="basicUrl" label="背景图">
          <template slot-scope="scope">
           
            <img :src="scope.row.basicUrl" class="imglist" />
          </template>
        </el-table-column>
        <el-table-column prop="id" label="ID"></el-table-column>
        <el-table-column
          prop="qrCodeHeight"
          label="二维码宽度"
        ></el-table-column>
        <el-table-column
          prop="qrCodeWidth"
          label="二维码高度"
        ></el-table-column>
        <el-table-column prop="qrCodeX" label="二维码X轴"></el-table-column>
        <el-table-column prop="qrCodeY" label="二维码Y轴"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="primary"
              icon="el-icon-edit"
              circle
              size="small"
              @click="handleEdit(scope.row)"
            ></el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              circle
              size="small"
              @click="handleRemove(scope.row.id)"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <update-list :onePoster="chooseOne" :baseDomain='baseDomain'/>
  </div>
</template>
<script>
import Upload from 'components/upload';
import { mapActions, mapState, mapMutations,mapGetters} from 'vuex';
import updateList from '../update';

export default {
  data() {
    return {
      chooseOne: {},
      baseDomain:''
    };
  },
  computed: {
    ...mapState('poster', ['poserlist']),
    // ...mapGetters('poster', ['poserlist']),
   
  },
  methods: {
    ...mapActions('poster', ['list', 'remove']),
    ...mapMutations('poster', ['setupdatePosterDialog']),
    handleEdit(item) {
      this.chooseOne = item;
      this.setupdatePosterDialog(true);
    },
    handleRemove(id) {
      this.$confirm('确认要删除该海报吗？', '提示', { type: 'warning' }).then(
        () => {
          this.remove(id).then(() => {
            this.$message.success('删除成功！');
            this.$emit('refresh');
          });
        }
      );
    },
    getDomain(){
      const { protocol } = window.location;
      const res=document.domain
      console.log('domain-res',res);
      console.log('protocol',protocol);
      this.baseDomain= protocol+'//'+res
      },
  },
  components: {
    updateList
  }
};
</script>
<style lang="less">
.imglist {
  max-height: 100px;
  height: 30px;
}
</style>
